module.exports = __webpack_public_path__ + "img/20191016163134399.32cc98b1.jpg";